import { render, staticRenderFns } from "./PerfilPermissao.vue?vue&type=template&id=a1edddb0&"
import script from "./PerfilPermissao.vue?vue&type=script&lang=js&"
export * from "./PerfilPermissao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports